// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3nQLk","rootCenter":"LoadMoreObserver_rootCenter__1ayfn","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3veRb"};